<div class="hierarchy-container">
  <mat-form-field class="hierarchy-type-filter" appearance="outline">
    <mat-label>{{'hierarchies.hierarchy-type-select-label' | translate}}</mat-label>
    <mat-select [(value)]="selectedHierarchyType" (selectionChange)="selectHierarchyType()"
      (opened)="filterInput.focus()">
      <mat-option disabled>
        <input #filterInput matInput (keyup)="filterHierarchyTypes($event)"
          placeholder="{{'hierarchies.filters.ph-filter' | translate}}">
      </mat-option>
      <mat-option *ngFor="let ht of selectableHierarchyTypes" [value]="ht">{{ht.displayText}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="selectedHierarchyType" class="hierarchy-main-container">
    <p class="root-title">{{'hierarchies.roots.title' | translate}}</p>
    <mat-expansion-panel class="hierarchy-filters" *ngIf="hierarchyRootObjects.data.length">
      <mat-expansion-panel-header class="hierarchy-filter-header" matRipple>
        <p class="title no-select"><mat-icon
            class="title-icon">filter_list</mat-icon>{{'hierarchies.filters.item-filter' |
          translate}}</p>
      </mat-expansion-panel-header>
      <div class="filter-content">
        <div class="item-filters" [formGroup]="filters">
          <mat-form-field appearance="outline" class="filter-item">
            <mat-label>{{'hierarchies.roots.header.id' | translate}}</mat-label>
            <input matInput formControlName="hierarchyObjectId">
            <button *ngIf="!emptyFilter('hierarchyObjectId')" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearFilter('hierarchyObjectId', $event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" class="filter-item">
            <mat-label>{{'hierarchies.roots.header.type-name' | translate}}</mat-label>
            <input matInput formControlName="hierarchyObjectTypeName">
            <button *ngIf="!emptyFilter('hierarchyObjectTypeName')" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearFilter('hierarchyObjectTypeName', $event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline" class="filter-item">
            <mat-label>{{'hierarchies.roots.header.ext-device-id' | translate}}</mat-label>
            <input matInput formControlName="extDeviceId">
            <button *ngIf="!emptyFilter('extDeviceId')" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearFilter('extDeviceId', $event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <mat-expansion-panel [(expanded)]="showColumnFilter" class="hierarchy-filters">
          <mat-expansion-panel-header class="hierarchy-filter-header" matRipple>
            <p class="title no-select"><mat-icon
                class="title-icon material-icons-outlined">view_column</mat-icon>{{'hierarchies.filters.column-filter' |
              translate}}</p>
          </mat-expansion-panel-header>
          <mat-button-toggle-group [multiple]="true" #rootObjectsGroup="matButtonToggleGroup"
            [(ngModel)]="rootObjectsColumnsToggle" class="hierarchy-toggle">
            <mat-button-toggle value="hierarchyObjectId" class="hierarchy-toggle-item">
              <span>{{'hierarchies.roots.header.id' | translate}}</span>
            </mat-button-toggle>
            <mat-button-toggle value="hierarchyObjectTypeName" class="hierarchy-toggle-item">
              <span>{{'hierarchies.roots.header.type-name' | translate}}</span>
            </mat-button-toggle>
            <mat-button-toggle value="extDeviceId" class="hierarchy-toggle-item">
              <span>{{'hierarchies.roots.header.ext-device-id' | translate}}</span>
            </mat-button-toggle>
            <mat-button-toggle *ngFor="let disCol of attributeColumns; let colIndex = index" [value]="disCol"
              class="hierarchy-toggle-item">
              <span>{{disCol}}</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </mat-expansion-panel>
      </div>
    </mat-expansion-panel>
    <div class="loading-overlay" *ngIf="isLoading">
      <mat-progress-spinner mode="indeterminate" diameter="50" />
    </div>
    <div class="hierarchy-table-container">
      <table mat-table [dataSource]="hierarchyRootObjects" multiTemplateDataRows matSort aria-label="hierarchies">
        <ng-container matColumnDef="hierarchyObjectId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'hierarchies.roots.header.id' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">{{element.hierarchyObjectId}}</td>
        </ng-container>
        <ng-container matColumnDef="hierarchyObjectTypeName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'hierarchies.roots.header.type-name' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">{{element.displayText}}</td>
        </ng-container>
        <ng-container matColumnDef="extDeviceId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'hierarchies.roots.header.ext-device-id' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">{{element.extDeviceId}}</td>
        </ng-container>

        <ng-container *ngFor="let disCol of attributeColumns; let colIndex = index" matColumnDef="{{disCol}}">
          <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
          <td mat-cell *matCellDef="let element">{{element?.attributes &&
            element.attributes[colIndex].valueDisplayText}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="filteredColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: filteredColumns;" (click)="onRowClick(row)">
        </tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data-cell" colspan="4">{{'table.no-records' | translate}}</td>
        </tr>
      </table>
    </div>
    <mat-paginator #rootObjectsPaginator [pageSizeOptions]="[5, 10, 25, 50]" [showFirstLastButtons]="!mobile"
      [hidePageSize]="mobile" />

    <ng-template #graphDialog>
      <mat-toolbar mat-dialog-title color="primary" class="graph-modal-toolbar" *ngIf="selectedElement">
        <span class="graph-modal-header">{{selectedElement.hierarchyObjectId}} - {{selectedElement.displayText}}</span>
      </mat-toolbar>
      <div *ngIf="selectedElement" class="graph-container">
        <div #graphContainer class="graph-node-content">
          <ngx-graph [view]="[graphContainer.offsetWidth, graphContainer.offsetHeight]" [nodes]="graphSettings.nodes"
            [links]="graphSettings.links" [autoZoom]="graphSettings.autoZoom" [autoCenter]="graphSettings.autoCenter"
            [zoomLevel]="graphSettings.zoomLevel" [minZoomLevel]="graphSettings.minZoomLevel"
            [maxZoomLevel]="graphSettings.maxZoomLevel" [layoutSettings]="graphSettings.layout"
            [draggingEnabled]="graphSettings.draggingEnabled" [showMiniMap]="graphSettings.showMiniMap">
            <ng-template #nodeTemplate let-node>
              <svg:g class="node">
                <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
                  [attr.fill]="node.data.customColor" />
                <svg:text alignment-baseline="central" [attr.x]="10" [attr.y]="node.dimension.height / 2">{{node.label}}
                </svg:text>
              </svg:g>
            </ng-template>
          </ngx-graph>
          <div class="graph-controls">
            <button class="graph-controls-button" mat-icon-button color="primary" (mousedown)="zoom()"
              (touchstart)="zoom()" (mouseup)="stopZoom()" (mouseleave)="stopZoom()" (touchend)="stopZoom()">
              <mat-icon color="primary">zoom_in</mat-icon>
            </button>
            <button class="graph-controls-button" mat-icon-button color="primary" (mousedown)="zoom(false)"
              (touchstart)="zoom(false)" (mouseup)="stopZoom()" (mouseleave)="stopZoom()" (touchend)="stopZoom()">
              <mat-icon color="primary">zoom_out</mat-icon>
            </button>
          </div>
        </div>
        <mat-dialog-actions align="center" class="graph-dialog-actions">
          <button mat-flat-button [mat-dialog-close]="true" color="primary"
            class="graph-modal-close-btn">{{'button.close'
            | translate}}</button>
        </mat-dialog-actions>
      </div>
    </ng-template>

  </div>
</div>